<template>
  <div class="mt-10">
    <template v-if="loading">
      <v-skeleton-loader type="article" v-for="n in 5" :key="n"> </v-skeleton-loader>
    </template>
    <div v-else-if="atestados.length === 0">
      <v-alert type="warning" :value="true">
        Não foi encontrado nenhum atestado
      </v-alert>
    </div>
    <AtestadoCard
      v-else
      @on-click-edit="$emit('on-click-edit', $event)"
      v-for="atestado in atestados"
      :key="atestado.id"
      :atestado="atestado"
    />
  </div>
</template>

<script>
import AtestadoCard from './AtestadoCard'
import atestadoService from '@/services/atestado'

export default {
  name: 'ListarAtestado',
  data() {
    return {
      loading: false,
      atestados: []
    }
  },
  components: {
    AtestadoCard
  },
  methods: {
    async fetchAtestados() {
      try {
        this.loading = true
        const { data } = await atestadoService.listarAtestados(this.atestado)
        this.atestados = data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.fetchAtestados()
  }
}
</script>
